export default {
  nl2br (str) {
    if (!str) {
      return ''
    }
    return str.replace(/(?:\r\n|\r|\n)/g, '<br/>')
  },
  getQueryParams () {
    let str = window.location.search.substr(1).split('&')
    if (str === '') return {}
    let b = {}
    for (var i = 0; i < str.length; ++i) {
      var p = str[i].split('=', 2)
      if (p.length === 1) {
        b[p[0]] = ''
      } else {
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '))
      }
    }
    return b
  }
}
